import { render, staticRenderFns } from "./landCardDetailCopy.vue?vue&type=template&id=8a5de6fa&scoped=true"
import script from "./landCardDetailCopy.vue?vue&type=script&lang=js"
export * from "./landCardDetailCopy.vue?vue&type=script&lang=js"
import style0 from "./landCardDetailCopy.vue?vue&type=style&index=0&id=8a5de6fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5de6fa",
  null
  
)

export default component.exports